'use client';

import { SvgAiSpark, SvgChevrondown } from '@common/icon';
import { cn } from '@core/utils';
import { useEffect, useState } from 'react';

import { SELECTOR } from '@/constants';

interface AiSummaryProps {
  aiSummaryList: string[];
}

export const AiSummary = ({ aiSummaryList }: AiSummaryProps) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (location.hash === '#' + SELECTOR.COMMENT_LIST_TOP) return;

    const timer = setTimeout(() => setIsOpen(true), 1_000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={cn(
        'flex w-full flex-col items-start overflow-hidden rounded-medium border border-B-50 px-20 py-16 shadow-md-reverse',
        'bg-[linear-gradient(128deg,theme(colors.Gray.white)_0%,theme(colors.B.25)_50%,theme(colors.Y.25)_100%)]',
      )}
    >
      <button
        type="button"
        aria-expanded={isOpen}
        className="flex w-full items-center gap-4"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <span className="flex size-20 items-center justify-center">
          <SvgAiSpark className="size-16" />
        </span>
        <span className="flex-1 text-left font-700 tracking-[-0.28px] text-Gray-900 typo-body4">
          정책을 <span className="text-B-500">AI</span>로 요약했어요
        </span>
        <span className="flex size-20 items-center justify-center">
          <SvgChevrondown
            className={cn(
              'size-16 text-Gray-900 transition-transform duration-200',
              isOpen && '-rotate-180',
            )}
          />
        </span>
      </button>
      <div
        aria-hidden={!isOpen}
        className={cn(
          'grid w-full transition-[grid-template-rows] duration-300 ease-out',
          isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]',
        )}
      >
        <div className="overflow-hidden">
          <div className="flex flex-col gap-12 pt-16">
            {aiSummaryList.map((value, index) => (
              <p
                key={index}
                className="font-400 tracking-[-0.28px] text-Gray-900 typo-body4"
              >
                {value}
              </p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
